import { INITIAL_GET_RESULTS_PAGING_REDUCER } from '../../constants/reducer'

import { IS_NEW_CONVERSATION, TEMP_ID_NEW_CONVERSATION } from '../../pages/ChatPage/fields'

export function handleAddUserMessageToConversation({ state, action, isExistingConversation }) {
  if (isExistingConversation) {
    // If we send a message to an existing conversation - add it to the messages
    const conversationId = action.params.params.extra_context.conversation_id
    const conversation = state.aiConversations.byId[conversationId]

    return {
      aiConversations: {
        byId: {
          [conversationId]: {
            $merge: {
              request_id: action.requestId,
              isLoading: true,
              modified: new Date().toISOString(), // Update the modified field when sending a new message
              messages: {
                ...conversation.messages,
                results: [
                  ...conversation.messages.results,
                  {
                    role: 'user',
                    content: action.params.params.text
                  }
                ]
              }
            }
          }
        },
        // Reorder conversations to show the most recently active one at the top
        // This is crucial for the ChatSidebar component which displays conversations
        // ordered by the 'modified' timestamp, ensuring the conversation a user just
        // interacted with appears at the top of the list for better user experience
        allIds: {
          $apply: ids => {
            // Remove the conversation ID from the array
            const filteredIds = ids.filter(id => {
              return String(id) !== String(conversationId)
            })
            // Add it back at the beginning of the array to make it appear first in the list
            return [conversationId, ...filteredIds]
          }
        }
      }
    }
  } else {
    // If it's a new conversation - add it to byId and allIds
    const newConversation = {
      // when the user message is sent to the new conversation, we don't have an id yet
      // we get it in the first chunk of messages, so use TEMP_ID_NEW_CONVERSATION
      id: TEMP_ID_NEW_CONVERSATION,
      title: action.params.extra_context.title,
      modified: new Date().toISOString(),
      request_id: action.requestId,
      isLoading: true,
      [IS_NEW_CONVERSATION]: true,
      messages: {
        ...INITIAL_GET_RESULTS_PAGING_REDUCER,
        results: [
          {
            role: 'user',
            content: action.params.text
          }
        ]
      }
    }

    return {
      aiConversations: {
        byId: {
          $merge: {
            [TEMP_ID_NEW_CONVERSATION]: newConversation
          }
        },
        allIds: {
          $unshift: [TEMP_ID_NEW_CONVERSATION]
        }
      }
    }
  }
}
